export default class CoolConsoleLog {
  private toString(obj: any): string {
    let str = '';

    Object.keys(obj).forEach(key => {
      str += `${key}: ${obj[key]};`;
    });

    return str;
  }

  pimpIt(): void {
    console.log(`%cTheo Costantini | Freelance (web) developper`, this.toString({
      'display': 'inline-block',
      'width': '100%',
      'padding': '10px 15px',
      'background-color': '#333333',
      'color': '#F7F7F7',
      'font-family': '"Helvetica Neue", Helvetica, Arial, sans-serif',
      'font-size': '16px',
      'font-weight': 'bold',
    }));
    console.log(`%cMail\t\t\t%chello@theocostantini.com`,
      this.toString({
        'padding-left': '15px',
        'color': '#333333',
        'font-family': '"Helvetica Neue", Helvetica, Arial, sans-serif',
        'font-size': '12px',
      }),
      this.toString({
        'color': '#B0B0B0',
        'font-family': '"Helvetica Neue", Helvetica, Arial, sans-serif',
        'font-size': '12px',
      }),
    );
    console.log(`%cGithub\t\t%cYellowFish085`,
      this.toString({
        'padding-left': '15px',
        'color': '#333333',
        'font-family': '"Helvetica Neue", Helvetica, Arial, sans-serif',
        'font-size': '12px',
      }),
      this.toString({
        'color': '#B0B0B0',
        'font-family': '"Helvetica Neue", Helvetica, Arial, sans-serif',
        'font-size': '12px',
      }),
    );
    console.log(`%cDon't hesitate to contact me for any project or idea. I'm a nice guy.`,
      this.toString({
        'display': 'inline-block',
        'padding': '5px 15px',
        'color': '#B0B0B0',
        'font-family': '"Helvetica Neue", Helvetica, Arial, sans-serif',
        'font-size': '12px',
      }),
    );
  }
}
